import { AnswersArticleFilterEditorPlatform } from '@wix/ambassador-cc-helpcenter-v1-related-document/types';

import { EDITOR_TYPE } from '../common/messageCreators/siteSelector';
import { renderModel } from './renderModel';

export const editorTypeToFilterPlatform: Partial<Record<EDITOR_TYPE, AnswersArticleFilterEditorPlatform>> = {
  [EDITOR_TYPE.EDITOR]: AnswersArticleFilterEditorPlatform.EDITOR,
  [EDITOR_TYPE.EDITOR3]: AnswersArticleFilterEditorPlatform.EDITOR_3,
  [EDITOR_TYPE.STUDIO]: AnswersArticleFilterEditorPlatform.STUDIO,
  [EDITOR_TYPE.PICASSO]: AnswersArticleFilterEditorPlatform.PICASSO,
  [EDITOR_TYPE.ODEDITOR]: AnswersArticleFilterEditorPlatform.EDITOR_3,
};

export function getEditorTypeFilter(): AnswersArticleFilterEditorPlatform | undefined {
  if (renderModel.isEditor3()) {
    return AnswersArticleFilterEditorPlatform.EDITOR_3;
  }

  if (renderModel.isStudioEditor()) {
    return AnswersArticleFilterEditorPlatform.STUDIO;
  }

  if (renderModel.isEditor()) {
    return AnswersArticleFilterEditorPlatform.EDITOR;
  }

  return undefined;
}
